import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FloatingLabel, Form, Image } from "react-bootstrap";
import { toast } from "react-toastify";

import Utils from "../configs/Utils";
import Enums from "../configs/Enums";
import Loading from "../Components/Common/Loading";

import "../assets/css/account.scss";

const ForgotPassword = () => {
  const emailRef = useRef(null);
  const [formLoading, setFormLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [emailErrMsg, setEmailErrMsg] = useState("");
  const [submittedEmail, setSubmittedEmail] = useState("");

  useEffect(() => {
    Utils.setPageTitle("Forgot password");
    emailRef.current?.focus();
  }, []);

  const clearErrMessage = () => {
    setEmailErrMsg("");
  };

  const validateEmail = () => {
    if (!email.length) {
      setEmailErrMsg("This field is required!");
      return false;
    }

    if (!Enums.Regex.EMAIL.test(email)) {
      setEmailErrMsg("Please enter a valid email!");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail()) {
      return;
    }

    setFormLoading(true);

    try {
      const data = await Utils._apiRequest({
        path: Enums.endpoints.auth.FORGOT_PASSWORD,
        type: "POST",
        payload: { email },
      });

      if (data?.errors?.email) {
        setEmailErrMsg(data.errors.email);
        return;
      }

      if (data?.errors?.message) {
        toast.error(data.errors.message);
        return;
      }

      if (data?.message) {
        toast.success(data.message);
      } else {
        toast.success("Password reset link sent. Please check your email.");
      }

      setSubmittedEmail(email);
    } catch (error) {
      toast.error(error.message || "Failed to send password reset email.");
    } finally {
      setFormLoading(false);
    }
  };

  return (
    <main className="page-main account-page container">
      <section className="forgot-password-wrapper">
        <Form
          className={`p-4 p-md-5 border overflow-hidden shadow rounded-3 bg-body-tertiary${formLoading ? " loading" : ""}`}
          onSubmit={handleSubmit}
        >
          <Loading show={formLoading} />
          <h1 className="logo text-center">
            <Image
              src={Utils.getPublicImage("/assets/images/logo-main.png")}
              width={145}
              alt=""
            />
          </h1>

          <h2 className="h4 mb-2">Reset your password</h2>
          <p className="text-muted mb-4">
            Enter your email and we will send you a reset link.
          </p>

          {submittedEmail ? (
            <div className="alert alert-success" role="status">
              Reset instructions have been sent to <strong>{submittedEmail}</strong>.
            </div>
          ) : null}

          <FloatingLabel
            controlId="forgotPasswordEmailInput"
            label="Email address"
            className="mb-3"
          >
            <Form.Control
              ref={emailRef}
              type="email"
              value={email}
              className={emailErrMsg !== "" ? " is-invalid" : ""}
              placeholder="name@example.com"
              onChange={(e) => {
                setEmail(e.target.value);
                clearErrMessage();
              }}
            />

            {emailErrMsg !== "" ? (
              <p className="invalid-feedback">{emailErrMsg}</p>
            ) : null}
          </FloatingLabel>

          <button className="w-100 btn btn-lg btn-primary" type="submit">
            Send reset link
          </button>

          <div className="footer">
            <p className="mb-1">
              Remember your password? <Link to="/login">Back to login</Link>
            </p>
            <p className="mb-0">
              Need an account? <Link to="/register">Register</Link>
            </p>
          </div>
        </Form>
      </section>
    </main>
  );
};

export default ForgotPassword;